import { Component, Input, OnInit } from '@angular/core';
import { ResponsiveService } from 'src/app/core/services/admin/responsive.service';

@Component({
	selector: 'app-balloon-badge',
	templateUrl: './balloon-badge.component.html',
	styleUrls: ['./balloon-badge.component.scss'],
})
export class BalloonBadgeComponent implements OnInit {
	@Input() balloon: any;
	isMobile: boolean = true;

	NOTIFY = 30;

	constructor(private responsiveService: ResponsiveService) {
		this.responsiveService.viewMobileChanged.subscribe({
			next: (mobileView) => {
				this.isMobile = mobileView;
			},
		});
	}

	ngOnInit(): void {}
}
